/**
 * Types for GET /v1/securityGroups - List Security Groups (Paginated)
 */

import type { LC_PagedResult } from '@/api/shared/types';

// ===== UI Event Constants =====

export const SECURITY_GROUPING_LIST_REFRESH_EVENT = 'security-grouping-list-refresh' as const;

// ===== Pagination Constants =====

export const SECURITY_GROUPING_DEFAULT_PAGE_SIZE = 10;

// ===== Filter Types =====

export type SecurityGroupStatusFilter = 'enabled' | 'disabled' | 'all';

// ===== Transport Types (Backend DTOs) =====

/**
 * Security group item in list response (transport layer)
 */
export interface LC_SecurityGroupItem {
  id: number;
  code: string;
  groupName: string;
  enabled: boolean;
  createdAt: string;
  createdBy: string;
  sendsAttendanceStatus: boolean;
  modifiedAt?: string;
  modifiedBy?: string;
  idrex?: string | null;
  itemrex?: string | null;
  isRexActive?: boolean | null;
}

/**
 * Response for paginated security groups list
 * apiClient.unwrapEnvelope() restructures it as LC_PagedResult automatically
 */
export type LC_SecurityGroupListOut = LC_PagedResult<LC_SecurityGroupItem>;

// ===== Domain Models (Internal) =====

/**
 * Internal security group model for list items
 */
export interface SecurityGroupItem {
  id: number;
  code: string;
  name: string;
  isEnabled: boolean;
  createdDate: string;
  createdBy: string;
  sendsAttendanceStatus: boolean;
  modifiedDate?: string;
  modifiedBy?: string;
  idRex?: string | null;
  isRexActive: boolean;
}

/**
 * Paginated security groups list result
 */
export interface SecurityGroupListResult {
  items: SecurityGroupItem[];
  page: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
}

/**
 * Filters for security groups list query
 */
export interface SecurityGroupListFilters {
  page?: number;
  pageSize?: number;
  status?: SecurityGroupStatusFilter;
  searchText?: string;
  orderBy?: string;
  orderDirection?: 'ASC' | 'DESC';
  [key: string]: string | number | undefined;
}
